// @flow

import React, { useCallback, useState } from 'react';
import { includes } from 'lodash';
import MemoryCard from './MemoryCard';
import type { Card, CardsData } from './types';
import useWindowSize from '../utils/use_window_size';

type Props = {
  cards: CardsData,
  activeCards: CardsData,
  finishedCards: Array<number>,
  level: number,
  cardSize: number,
  turnCard: (card: Card) => void,
  fieldWidth: number,
  fieldHeight: number,
};

const gridCols = (level, portrait) => {
  const portraitLevels = l => ({
    1: 'grid-cols-2',
    2: 'grid-cols-3',
  }[l] || 'grid-cols-4');
  const landscapeCols = l => ({
    1: 'grid-cols-2',
    2: 'grid-cols-3',
    3: 'grid-cols-4',
    4: 'grid-cols-4',
    5: 'grid-cols-5',
    6: 'grid-cols-6',
    7: 'grid-cols-6',
  }[l]);
  return portrait ? portraitLevels(level) : landscapeCols(level);
};

const MemoryField = (props: Props) => {
  const [fieldSize, setFieldSize] = useState({ width: 0, height: 0 });
  const windowSize = useWindowSize();
  const field = useCallback((node) => {
    if (node !== null) {
      const size = node.getBoundingClientRect();
      setFieldSize({
        height: size.height,
        width: windowSize.width,
      });
    }
  }, [windowSize]);

  const {
    // fieldWidth,
    cards,
    assetPath,
    activeCards,
    finishedCards,
    turnCard,
    // cardSize,
    level,
  } = props;

  const fieldWidth = fieldSize.width;
  const fieldHeight = fieldSize.height;
  const portrait = fieldHeight > fieldWidth;
  const levelFactor = 0.1 + (1 / (level >= 2 ? level : 1.5));
  const cardSize = Math.min(
    fieldSize.width / (portrait ? 4 : 6),
    fieldSize.height / (portrait ? 6 : 4),
  ) * Math.max(levelFactor, 0.6);

  return (
    <div className="flex h-full" ref={field}>
      <div
        className={`justify-center gap-1 md:gap-6 items-center m-auto grid ${gridCols(level, portrait)}`}
      >
        {cards.map((card, index) => {
          const key = (level * 100) + index;
          if (card === null) {
            return (<div key={key} />);
          }
          const active = includes(activeCards, card);
          const turned = includes(finishedCards, card.id);
          return (<MemoryCard
            assetPath={assetPath}
            card={card}
            key={key}
            turned={turned}
            turnCard={turnCard}
            active={active}
            index={index}
            size={cardSize}
            level={level}
          />);
        })}
      </div>
    </div>
  );
};

export default MemoryField;
